import React from 'react'
import { chipImg, frameImg } from '../utils'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap';
import { animateWithGsap } from '../utils/animations';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';


const HowItWorks = () => {

  useGSAP(() => {
    gsap.from('#chip', {
      scrollTrigger: {
        trigger: '#chip',
        start: '20% bottom'
      },
      opacity: 0,
      scale: 2,
      duration: 2,
      ease: 'power2.inOut'
    })

    animateWithGsap('.g_fadeIn', {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: 'power2.inOut'
    })
  }, []);

  return (
    <section className="common-padding bg-white">
      <div className="screen-max-width">
        <div className="hi">
       <div id="chip" className="flex-center w-full my-20">
  <img
    src={chipImg}
    alt="chip"
    width={180}
    height={180}
    className="shadow-[0_10px_30px_rgba(0,0,0,0.25)] rounded-xl"
  />
</div>

        <div className="flex flex-col items-center">
          <h2 className="hiw-title text-gray-800">
          Our Services
           
          </h2>
        </div>
        </div>

        <div className="mt-10 md:mt-20 mb-14 px-4">
        <div className="hidden md:grid grid-cols-3 gap-1">
    
            {/* Left Content */}
            <div className="space-y-[100vh] md:space-y-10">
         <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center"
      >
        <h2 className="text-2xl font-bold mb-2 text-gray-800">Kitchen <span className='text-black'>Renovations</span></h2>
        <p className="text-gray-900 text-lg">
        Upgrade your kitchen into a modern, functional, and stylish space designed around your lifestyle. We handle complete kitchen renovations including layout redesigns, cabinet installation, countertops, lighting, flooring, plumbing, tiling, and finishing touches.</p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2 text-gray-800">House <span className='text-black'>Extensions</span></h2>
        <p className="text-gray-900 text-lg">Need more space for your growing family or lifestyle? Our house extension services help you expand your property while increasing its functionality and value. We manage every stage of the project from planning to completion.</p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }} className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2 text-gray-800">Attic <span className='text-black'>Conversions</span></h2>
        <p className="text-gray-900 text-lg">
       Transform unused attic space into a practical and beautiful room. Whether you want an additional bedroom, office, playroom, or storage area, we create attic conversions that maximize your home's potential.</p>
      </motion.div>

        <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }} className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2 text-gray-800">Bathroom <span className='text-black'>Renovations</span></h2>
        <p className="text-gray-900 text-lg">
       Transform your bathroom into a modern and relaxing space with our expert renovation services. We handle everything from layout planning and plumbing to tiling and final finishing.</p>
      </motion.div>
    </div>

          {/* Sticky Image */}
          <div className="relative">
      <div className="sticky top-28">
        <img
          src={frameImg}
          alt="frame"
          className="bg-transparent z-10 w-120 h-[22rem] mx-auto"
        />
      </div>
    </div>

    {/* Right Content */}
    <div className="space-y-[100vh] md:space-y-10">
    <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2 text-gray-800">Skimming <span className='text-black'>Service</span></h2>
        <p className="text-gray-900 text-lg">
       Achieve smooth and flawless walls and ceilings with our professional skimming services. We prepare surfaces carefully to ensure a perfect finish ready for painting or decorating.</p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2 text-gray-800">Flooring <span className='text-black'>Service</span></h2>
        <p className="text-gray-900 text-lg">
        Each property has relevant, up-to-date comparables to help our investors make the right choice for their goals.</p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2 text-gray-800">Tiling <span className='text-black'>Service</span></h2>
        <p className="text-gray-900 text-lg">
        We offer professional wall and floor tiling services for kitchens, bathrooms, hallways, and more. Our team delivers precise tile installation with attention to detail and high-quality finishes.</p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2 text-gray-800">Offices<span className='text-black'>Renovations</span></h2>
        <p className="text-gray-900 text-lg">
        We provide professional office renovation and fit-out services designed to create modern, functional, and productive workspaces tailored to your business needs.</p>
       
      </motion.div>
    
    </div>

  </div>
   {/* Mobile View */}
   <div className="md:hidden relative">
    {/* Wrapper that creates enough height for sticky effect */}
    <div className="relative h-[600vh]">
      <div className="sticky top-0 h-screen flex items-center justify-center z-10">
        <img
          src={frameImg}
          alt="frame"
          className="w-80 h-[25rem] mx-auto opacity-30"
        />
      </div>

      <div className="absolute top-0 left-0 right-0">
        {/* Left content */}
      
         <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center"
      >
        <h2 className="text-2xl font-bold mb-2 text-gray-800">Kitchen <span className='text-black'>Renovations</span></h2>
        <p className="text-gray-900 text-lg">
       Upgrade your kitchen into a modern, functional, and stylish space designed around your lifestyle. We handle complete kitchen renovations including layout redesigns, cabinet installation, countertops, lighting, flooring, plumbing, tiling, and finishing touches.</p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2 text-gray-800">House <span className='text-black'>Extensions</span></h2>
        <p className="text-gray-900 text-lg">Need more space for your growing family or lifestyle? Our house extension services help you expand your property while increasing its functionality and value. We manage every stage of the project from planning to completion.</p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }} className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2 text-gray-800">Attic <span className='text-black'>Conversions</span></h2>
        <p className="text-gray-900 text-lg">
        Transform unused attic space into a practical and beautiful room. Whether you want an additional bedroom, office, playroom, or storage area, we create attic conversions that maximize your home's potential.</p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }} className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2 text-gray-800">Tiling <span className='text-black'>Service</span></h2>
        <p className="text-gray-900 text-lg">
       We offer professional wall and floor tiling services for kitchens, bathrooms, hallways, and more. Our team delivers precise tile installation with attention to detail and high-quality finishes.</p>
      </motion.div>
   
      

        {/* Right content */}
        <div className="space-y-[100vh]">
        
    <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2 text-black">Skimming <span className='text-black'>Service</span></h2>
        <p className="text-gray-900 text-lg">
       Achieve smooth and flawless walls and ceilings with our professional skimming services. We prepare surfaces carefully to ensure a perfect finish ready for painting or decorating.</p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2 text-black">Flooring <span className='text-black'>Service</span></h2>
        <p className="text-gray-900 text-lg">
       We provide high-quality flooring installation services to enhance the beauty and durability of your property. From modern flooring designs to classic finishes, we help you choose the perfect option for your space.</p>
      </motion.div>
       <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2 text-black">Bathroom <span className='text-black'>Renovations</span></h2>
        <p className="text-gray-900 text-lg">
       Transform your bathroom into a modern and relaxing space with our expert renovation services. We handle everything from layout planning and plumbing to tiling and final finishing.</p>
      </motion.div>

<motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2 }}
        className="h-screen flex flex-col justify-center">
        <h2 className="text-2xl font-bold mb-2 text-black">Offices <span className='text-black'>Renovations</span></h2>
        <p className="text-gray-900 text-lg">
       We provide professional office renovation and fit-out services designed to create modern, functional, and productive workspaces tailored to your business needs.</p>


      </motion.div>
    
    </div>
          {/* Your motion divs */}
        </div>
      
    </div>
  </div>
</div>


<div className="relative z-20 -mt-[46vh] md:-mt-[32vh] bg-teal-600 p-10">
  <div className="flex flex-col md:flex-row items-center justify-between gap-6">
    <div className="flex-1 flex justify-center flex-col g_fadeIn text-white">
      <p className="hiw-bigtext text-3xl font-bold">Ready to Transform Your Home?</p>             
    </div>
    <div className="flex-1 flex justify-center flex-col text-white">
      <p className="text-xl g_fadeIn text-white">
       Get in touch today for a free consultation and quote..
      </p>
      <Link to="/contact"> 
        <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold bg-slate-900 shadow-xl text-lg group">
          <span className="absolute inset-0 bg-gradient-to-r from-teal-600 to-teal-600 group-hover:from-teal-600 group-hover:to-teal-600 animate-slide-bg transition-all duration-500 ease-in-out"></span>
          <span className="relative z-10">Contact Us</span>
        </button>
      </Link>     
    </div>
  </div>
</div>


     </div>
    </section>
  )
}

export default HowItWorks